// Actiondan gelen datalar ile stateler güncellenecek
export const reportLoading = (state, payload) => {
    state.loading = payload
}

export const signalReports = (state, payload) => {
    state.signalReport = payload 
}

export const setColumns = (state, payload) => {
    state.columns = payload.data
}

export const flexReport = (state, payload) => {
    state.flexReport = payload.data
}


// WEBPACK FOOTER //
// ./src/store/modules/Reports/Mutaions.js